import { combineReducers } from 'redux';
import adjustmentList from './adjustmentList/reducer';
import createEditAdjustment from './createEditAdjustment/reducer';

export default combineReducers({
  adjustmentList,
  createEditAdjustment,
});



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/adjustment/state/reducers.js